import { IconAlertTriangleFill } from "@amzn/stencil-react-components/icons";
import React from "react";
import { StatusEnum } from "../../hoc/with-status";
import "./styles.scss";
import useArb from "../../hooks/use-arb";

interface StatusProps {
  status?: StatusEnum;
}
const classNames = {
  [StatusEnum.LOADING]: "loading",
  [StatusEnum.NOT_STARTED]: "not-started",
  [StatusEnum.IN_PROGRESS]: "in-progress",
  [StatusEnum.COMPLETED]: "completed",
  [StatusEnum.API_ERROR]: "na",
  [StatusEnum.ERROR]: "error",
  [StatusEnum.HIDDEN]: "hidden",
  [StatusEnum.PENDING_REVIEW]: "in-progress",
  [StatusEnum.ELIGIBLE]: "eligible",
  [StatusEnum.INELIGIBLE]: "ineligible",
  [StatusEnum.INITIATED]: "in-progress",
  [StatusEnum.NOT_REQUIRED]: "not-required",
  [StatusEnum.NOT_AVAILABLE_YET]: "not-available-yet",
  [StatusEnum.ACTION_REQUIRED]: "action-required",
};

//generate the key for panther translation
function preprocessTaskStatusForTranslation(status: StatusEnum): string {
  let statusWithoutSpace = status.replace(/\s+/g, "");
  if (statusWithoutSpace == "N/A") {
    statusWithoutSpace = "NA";
  }
  return "checklist-General-TaskStatus-" + statusWithoutSpace;
}

export const Status = ({ status }: StatusProps) => {
  if (!status) {
    return null;
  }

  const className = `status ${classNames[status as StatusEnum]}`;
  if (status == StatusEnum.ERROR) {
    return (
      <span className={className}>
        <IconAlertTriangleFill color={"#cc7a00;"} />
      </span>
    );
  }
  const bundle = useArb("HVHChecklistPantherResource");
  const statusText =
    status == StatusEnum.INITIATED ? StatusEnum.IN_PROGRESS : status;
  const translation = bundle.getMessage(
    preprocessTaskStatusForTranslation(statusText)
  );

  return <span className={className}>{translation}</span>;
};
